
import { BaseApi } from './base';
import { Customer, CustomerFilters } from '../types';
import { supabase } from '../supabase';

class CustomersApi extends BaseApi {
  constructor() {
    super('customers');
  }

  async getCustomers(filters?: CustomerFilters): Promise<Customer[]> {
    let query = supabase
      .from('customers')
      .select('*')
      .order('created_at', { ascending: false });

    if (filters?.status) {
      query = query.eq('status', filters.status);
    }
    if (filters?.location) {
      query = query.ilike('address', `%${filters.location}%`);
    }

    const { data, error } = await query;
    if (error) {
      throw new Error(`Failed to fetch customers: ${error.message}`);
    }
    return data || [];
  }

  async searchCustomers(searchTerm: string): Promise<Customer[]> {
    const { data, error } = await supabase
      .from('customers')
      .select('*')
      .or(
        `name.ilike.%${searchTerm}%,email.ilike.%${searchTerm}%,phone.ilike.%${searchTerm}%,address.ilike.%${searchTerm}%`
      )
      .order('created_at', { ascending: false })
      .limit(50);

    if (error) {
      throw new Error(`Failed to search customers: ${error.message}`);
    }
    return data || [];
  }

  async getCustomerByPhone(phone: string): Promise<Customer | null> {
    const { data, error } = await supabase
      .from('customers')
      .select('*')
      .eq('phone', phone)
      .single();
    if (error) {
      return null;
    }
    return data as Customer;
  }

  async getCustomerByEmail(email: string): Promise<Customer | null> {
    const { data, error } = await supabase
      .from('customers')
      .select('*')
      .eq('email', email)
      .single();
    if (error) {
      return null;
    }
    return data as Customer;
  }
}

export const customersApi = new CustomersApi();
